<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/admin/overview">
        <img src="../../public/img/home.png" class="sidebar-icon">
        <p>Inicio</p>
      </sidebar-link>
      <sidebar-link to="/admin/users/admins">
        <img src="../../public/img/latydo.png" class="sidebar-icon">
        <!-- <i class="nc-icon nc-preferences-circle-rotate"></i> -->
        <p>Administradores</p>
      </sidebar-link>
      <sidebar-link to="/admin/doctors">
        <img src="../../public/img/doctor2.png" class="sidebar-icon">
        <p>Doctores</p>
      </sidebar-link>
      <sidebar-link to="/admin/patients">
        <img src="../../public/img/profile.png" class="sidebar-icon">
        <p>Pacientes</p>
      </sidebar-link>
      <sidebar-link to="/admin/services">
        <img src="../../public/img/services.png" class="sidebar-icon">
        <p>Servicios</p>
      </sidebar-link>
      <sidebar-link to="/admin/doctor_operations">
        <img src="../../public/img/wallet.png" class="sidebar-icon">
        <p>Operaciones Doctor</p>
      </sidebar-link>
      <sidebar-link to="/admin/patient_operations">
        <img src="../../public/img/wallet2.png" class="sidebar-icon">
        <p>Operaciones Pacientes</p>
      </sidebar-link>
      <sidebar-link to="/admin/banks">
        <img src="../../public/img/bank.png" class="sidebar-icon">
        <p>Bancos De Empresa</p>
      </sidebar-link>
      <sidebar-link to="/admin/configurations">
        <img src="../../public/img/config.png" class="sidebar-icon">
        <p>Configuraciones</p>
      </sidebar-link>
      <sidebar-link to="/admin/variable">
        <img src="../../public/img/edit.png" class="sidebar-icon">
        <p>Variables</p>
      </sidebar-link>
      <sidebar-link to="/admin/transports">
        <img src="../../public/img/bxs_ambulance.png" class="sidebar-icon">
        <p>Transportes</p>
      </sidebar-link>
      <sidebar-link to="/admin/notifications">
        <img src="../../public/img/message.png" class="sidebar-icon">
        <p>Notificaciones</p>
      </sidebar-link>


    </side-bar>
    <div class="main-panel" style="min-height: 100vh;">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<style>
.sidebar-icon {
  width: 27px;
  margin-right: 15px;
}
</style>
<script>
import TopNavbar from './TopNavbar.vue'
import ContentFooter from './ContentFooter.vue'
import DashboardContent from './Content.vue'
import MobileMenu from './MobileMenu.vue'
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    }
  }
}

</script>
